var _defs, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack1138({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "15 8 12.87 5.87 12.87 7.14 8.86 7.14 8.86 3.13 10.13 3.13 8 1 5.87 3.13 7.14 3.13 7.14 7.14 3.13 7.14 3.13 5.87 1 8 3.13 10.13 3.13 8.86 7.14 8.86 7.14 12.87 5.87 12.87 8 15 10.13 12.87 8.86 12.87 8.86 8.86 12.87 8.86 12.87 10.13 15 8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack1138);
export default __webpack_public_path__ + "static/media/Symbolpack_1_138.2ba34d25c1580e55286bb4d00fac398c.svg";
export { ForwardRef as ReactComponent };